import script from "./BackgroundBubble.vue?vue&type=script&setup=true&lang=ts"
export * from "./BackgroundBubble.vue?vue&type=script&setup=true&lang=ts"

import "./BackgroundBubble.vue?vue&type=style&index=0&id=352e88a2&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/ClementRivaille.github.io/ClementRivaille.github.io/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-352e88a2"]])

export default __exports__